import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  httpOptions: any;


 // =========================================================
  // SILENT DASHBOARD REFRESH
  // =========================================================

  private dashboardRefreshSubject = new Subject<void>();

  dashboardRefresh$ =
    this.dashboardRefreshSubject.asObservable();

  triggerDashboardRefresh(): void {
    this.dashboardRefreshSubject.next();
  }









  constructor(private http: HttpClient) {

    let accesstoken = localStorage.getItem('accessToken');
    if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + accesstoken,
          'No-Auth': 'True'
        })
      };
    }


  }

  /*
  Get_Dashboard_Data(){
    return this.http.get(`${environment.API_Base_URL}` + `DashBoard_Count/GetDashboardData`)
  }
  */
  Get_Patient() {
    return this.http.get(`${environment.API_Base_URL}` + `Patient/GetAllPatient`)
  }
  patientpayhistory() {
    return this.http.get(`${environment.API_Base_URL}` + `Payment/PaymentHistoryCCAve_PHC`)

  }
  Get_Approval_detail() {
    return this.http.get(`${environment.API_Base_URL}` + `Appointment/Admin/GetAppointmentSP`)
  }
  GetConsultationHistory() {
    return this.http.get(`${environment.API_Base_URL}` + `Consultation/GetConsultationHistory`)
  }
  totalpatientpayhistory() {
    return this.http.get(`${environment.API_Base_URL}` + `Payment/PaymentHistoryCCAve_PHC`)
  }
  Get_totalPatient() {
    return this.http.get(`${environment.API_Base_URL}` + `Patient/GetAllPatient`)
  }
  GettotalConsultationHistory() {
    return this.http.get(`${environment.API_Base_URL}` + `Consultation/GetConsultationHistory`)
  }
  Get_totalApproval_detail() {
    return this.http.get(`${environment.API_Base_URL}` + `Appointment/Admin/GetAppointmentSP`)
  }
  patientpaysuccesshistory() {
    return this.http.get(`${environment.API_Base_URL}` + `Payment/PaymentHistoryCCAve_PHC`)


  }



  GetHomecareDashboard(hospitalId: any, p0?: boolean) {
    return this.http.get(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboard/${hospitalId}`, this.httpOptions
    );
  }











  /*
  GetHomecareDashboard(userId: string, hospitalId: number) {
  
    return this.http.get(
      environment.API_Base_URL +
      'HomeCare/GetDashboard?userId=' +
      userId +
      '&hospitalId=' +
      hospitalId
    );
  
  }
  */
  GetHomecareDashboardPendingRequests(
    roleName: string,
    hospitalId: number
  ) {

    return this.http.get(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardPendingRequests?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );

  }



  GetHomecareDashboardPendingPayments(roleName: any, hospitalId: any) {
    return this.http.get(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardPendingPayments?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );
  }


  GetHomecareDashboardPendingServices(roleName: any, hospitalId: any) {
    return this.http.get(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardPendingServices?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );
  }


  GetHomecareDashboardActiveServices(roleName: any, hospitalId: any) {
    return this.http.get(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardActiveServices?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );
  }

  GetHomecareDashboardCompletedServices(roleName: any, hospitalId: any) {
    return this.http.get(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardCompletedServices?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );
  }

  GetHomecareDashboardCancelledServices(roleName: any, hospitalId: any) {
    return this.http.get(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardCancelledServices?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );
  }
  GetHomecareDashboardSuccessfulPayments(
    roleName: string,
    hospitalId: number
  ) {
    return this.http.get<any>(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardSuccessfulPayments?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );
  }
  GetHomecareDashboardTodaysRevenue(
    roleName: string,
    hospitalId: number
  ): Observable<any> {

    const url =
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardTodaysRevenue` +
      `?roleName=${roleName}&hospitalId=${hospitalId}`;

    console.log(
      "Today's Revenue API URL:",
      url
    );

    return this.http.get<any>(url, this.httpOptions);

  }

  GetHomecareDashboardMonthlyRevenue(
    roleName: string,
    hospitalId: number
  ): Observable<any> {
    const url =
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardMonthlyRevenue` +
      `?roleName=${roleName}&hospitalId=${hospitalId}`;
    console.log('Monthly Revenue API URL:', url
    );
    return this.http.get<any>(url, this.httpOptions);
  }

  GetHomecareDashboardRegisteredCaregivers(
    roleName: string,
    hospitalId: number
  ): Observable<any> {
    const url =
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardRegisteredCaregivers` +
      `?roleName=${roleName}&hospitalId=${hospitalId}`;

    console.log('Registered Caregivers API URL:', url
    );
    return this.http.get<any>(url, this.httpOptions
    );
  }

  GetHomecareDashboardUnAssignedCaregivers(
    roleName: string,
    hospitalId: number
  ) {
    return this.http.get(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardUnAssignedCaregivers?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );
  }

  GetHomecareDashboardAssignedCaregivers(
    roleName: string,
    hospitalId: number
  ) {
    return this.http.get(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardAssignedCaregivers?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );
  }

  GetHomecareDashboardRegisteredPatients(
    roleName: string,
    hospitalId: number
  ): Observable<any> {
    return this.http.get<any>(
      `${environment.API_Base_URL}HomeCare/GetHomecareDashboardRegisteredPatients?roleName=${roleName}&hospitalId=${hospitalId}`,
      this.httpOptions
    );

  }

  GetHomecareDashboardRegisteredCoordinators(
    roleName: string,
    hospitalId: number
  ): Observable<any> {
    const url =
      `${environment.API_Base_URL}` +
      `HomeCare/GetHomecareDashboardRegisteredCoordinators` +
      `?roleName=${roleName}&hospitalId=${hospitalId}`;
    console.log('Registered Coordinators API URL:', url);
    return this.http.get<any>(url, this.httpOptions);
  }

  GetHomecareDashboardActiveCoordinators(
    roleName: string,
    hospitalId: number
  ): Observable<any> {
    const url =
      `${environment.API_Base_URL}` +
      `HomeCare/GetHomecareDashboardActiveCoordinators` +
      `?roleName=${roleName}&hospitalId=${hospitalId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

//saheb
   GetHospitalLogoById(hospitalId: any) {
    return this.http.get(
      `${environment.API_Base_URL}Hospital/GetHospitalLogo/${hospitalId}`, this.httpOptions
    );
  }






  
}
